import { Chip, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import {
  OnHoldTripLegApproveDenyAction,
  ReservationStatus,
} from '../../../data/models/reservation.model';
import { useCanReadCSASupervisor } from '../../../hooks/permissions/useCanReadCSASupervisor';

const PREFIX = 'StatusChip';

const classes = {
  chip: `${PREFIX}-chip`,
};

const StyledChip = styled(Chip)(({ theme }) => ({
  [`&.${classes.chip}`]: {
    '.MuiChip-label': {
      color: `${theme.palette.primary.main}`,
    },
    backgroundColor: '#0288d11f',
  },
}));

interface StatusChipProps {
  status: string;
  onApproveOrDeny?: Function;
}

export default function StatusChip({
  status,
  onApproveOrDeny = () => {},
}: StatusChipProps) {
  const isCSASupervisor = useCanReadCSASupervisor();
  const { t } = useTranslation('common');
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<any>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  if (status === ReservationStatus.OnHold && isCSASupervisor) {
    return (
      <>
        <StyledChip
          className={classes.chip}
          label={status}
          onClick={handleClick}
        />
        <Menu
          anchorEl={anchorEl}
          open={openMenu}
          onClose={handleMenuClose}
          onClick={handleMenuClose}>
          <MenuList>
            <MenuItem
              onClick={() =>
                onApproveOrDeny(OnHoldTripLegApproveDenyAction.Approve)
              }>
              <ListItemIcon>
                <CheckCircleOutlineIcon />
              </ListItemIcon>
              <ListItemText>Approve</ListItemText>
            </MenuItem>
            <MenuItem
              onClick={() =>
                onApproveOrDeny(OnHoldTripLegApproveDenyAction.Deny)
              }>
              <ListItemIcon>
                <HighlightOffIcon />
              </ListItemIcon>
              <ListItemText>Deny</ListItemText>
            </MenuItem>
          </MenuList>
        </Menu>
      </>
    );
  } else {
    return <StyledChip className={classes.chip} label={status} />;
  }
}
